import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView, ActivityIndicator, FlatList } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import Icon from '../../icon/Icon';
import CustomerListType from './CustomerListType';
import DropDownBaseInput from '../../dropDownInput/DropDownBaseInput';
import TextInput from '../../textInput/TextInput';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import Space from '../../space/Space';
import Divider from '../../divider/Divider';
import EmptyScreen from '../customerDetailsTable/EmptyScreen';
import ShimmerTable from '../customerDetailsTable/ShimmerTable';
import { isCloseToBottom } from '../../stack/utils';
import RenewalContent from '../customerDetailsTable/RenewalContent';
import ShortfallContent from '../customerDetailsTable/ShortfallContent';
import { addCommasToNumber, showPlj, showShareLink } from '../utils';
const customerTypeData = [
    { label: 'All Cutomers', value: 'CUSTOMER' },
    { label: 'Interest due', value: 'INTEREST' },
    { label: 'Renewal due', value: 'RENEWAL' },
    { label: 'Shortfall', value: 'SHORTFALL' },
];
const CustomerMobDashboard = ({ height, tabData, dataFetched, filterObj, showDashboardCard = true, customerData, activeTab, actualPageSizeCustomer, totalNoOfPages, navigateToCustomerScreen, navigateToInterestScreen, navigateToRenewalScreen, navigateToShortfallScreen, navigateToCustomerScreenDebounce, navigateToInterestScreenDebounce, navigateToRenewalScreenDebounce, navigateToShortfallScreenDebounce, navigateToCustomerFilter, navigateToInterestFilter, navigateToRenewalFilter, navigateToShortfallFilter, navigateToCustomerDetails, navigateToShareLink, navigateToCustomerJourney, navigateToInterestCalculator, numberOfFilterApplied, triggerAction, }) => {
    const scrollViewRef = React.useRef(null);
    const [showDashboard, setShowDashboard] = useState(activeTab >= 0 ? false : showDashboardCard);
    const [customerType, setCustomerType] = useState('');
    const [searchText, setSearchText] = useState('');
    const [currentActiveTab, setCurrentActiveTab] = useState(activeTab);
    const [currentPageNumber, setCurrentpageNumber] = useState(2);
    const [data, setData] = useState([]);
    const [isFilterSelected, setIsFilterSelected] = useState(numberOfFilterApplied > 0 ? true : false);
    const [showRenewalInfo, setShowRenewalInfo] = useState(false);
    const [showShortfallInfo, setShowShortfallInfo] = useState(false);
    const [showRenewalOption, setShowRenewalOption] = useState(customerData?.length > 0 ? true : false);
    const [showShortfallOption, setShowShortfallOption] = useState(customerData?.length > 0 ? true : false);
    const [newFilterObj, setNewFilterObj] = useState(filterObj);
    const [hasReachedBottom, setHasReachedBottom] = useState(false);
    const [isDataFetched, setDataFetched] = useState(dataFetched);
    const [showJourney, setShowJourney] = useState(showPlj());
    const [showLink, setShowLink] = useState(showShareLink());
    useEffect(() => {
        setData(prevData => prevData.concat(customerData));
    }, [customerData]);
    useEffect(() => {
        setDataFetched(dataFetched);
    }, [dataFetched]);
    useEffect(() => {
        setShowRenewalOption(customerData?.length > 0 ? true : false);
        setShowShortfallOption(customerData?.length > 0 ? true : false);
    }, [customerData]);
    const handleBackPress = () => {
        setShowDashboard(true);
        setIsFilterSelected(false);
    };
    const clearTextSearchAction = () => {
        setSearchText('');
    };
    const fetchMoreData = async () => {
        if (currentActiveTab === 1) {
            await triggerAction({
                ...navigateToInterestScreenDebounce,
                payload: {
                    searchText,
                    currentPage: currentPageNumber,
                    renderFilterSelected: isFilterSelected ? newFilterObj : {},
                    ...navigateToInterestScreenDebounce.payload
                }
            });
        }
        else if (currentActiveTab === 2) {
            await triggerAction({
                ...navigateToRenewalScreenDebounce,
                payload: {
                    searchText,
                    currentPage: currentPageNumber,
                    renderFilterSelected: isFilterSelected ? newFilterObj : {},
                    ...navigateToRenewalScreenDebounce.payload
                }
            });
        }
        else if (currentActiveTab === 3) {
            await triggerAction({
                ...navigateToShortfallScreenDebounce,
                payload: {
                    searchText,
                    currentPage: currentPageNumber,
                    renderFilterSelected: isFilterSelected ? newFilterObj : {},
                    ...navigateToShortfallScreenDebounce.payload
                }
            });
        }
        else {
            await triggerAction({
                ...navigateToCustomerScreenDebounce,
                payload: {
                    searchText,
                    currentPage: currentPageNumber,
                    renderFilterSelected: isFilterSelected ? newFilterObj : {},
                    ...navigateToCustomerScreenDebounce.payload
                }
            });
        }
    };
    const handleSearch = async (text) => {
        setData([]);
        setDataFetched(false);
        if (currentActiveTab === 1) {
            await triggerAction({
                ...navigateToInterestScreenDebounce,
                payload: {
                    searchText: text,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilterObj : {},
                    ...navigateToInterestScreenDebounce.payload
                }
            });
        }
        else if (currentActiveTab === 2) {
            await triggerAction({
                ...navigateToRenewalScreenDebounce,
                payload: {
                    searchText: text,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilterObj : {},
                    ...navigateToRenewalScreenDebounce.payload
                }
            });
        }
        else if (currentActiveTab === 3) {
            await triggerAction({
                ...navigateToShortfallScreenDebounce,
                payload: {
                    searchText: text,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilterObj : {},
                    ...navigateToShortfallScreenDebounce.payload
                }
            });
        }
        else {
            await triggerAction({
                ...navigateToCustomerScreenDebounce,
                payload: {
                    searchText: text,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilterObj : {},
                    ...navigateToCustomerScreenDebounce.payload
                }
            });
        }
    };
    const handlePageNavigation = (tabIndex) => {
        setShowDashboard(false);
        setCurrentActiveTab(tabIndex);
    };
    const renderDashboardDetails = () => {
        return (React.createElement(View, { style: { margin: 16, marginBottom: 60 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Customers', color: ColorTokens.Grey_Night }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Track your active customers', color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(CustomerListType, { title: 'All customer', iconName: IconTokens.SYSTEM_INVESTOR_DLS, count: tabData[0]?.count > 0 ? tabData[0]?.count : '0', bgColor: '#98A2B3', action: navigateToCustomerScreen, triggerAction: triggerAction, handleNavigation: () => handlePageNavigation(0), setData: setData })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(CustomerListType, { title: 'Interest due', iconName: IconTokens.Percentage, count: tabData[1]?.count > 0 ? tabData[1]?.count : '0', bgColor: tabData[1].count > 0 ? '#FF7B7E' : '#98A2B3', action: navigateToInterestScreen, triggerAction: triggerAction, handleNavigation: () => handlePageNavigation(1), setData: setData })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(CustomerListType, { title: 'Renewal due', iconName: IconTokens.LOAN_RENEW, count: tabData[2]?.count > 0 ? tabData[2]?.count : '0', bgColor: tabData[2].count > 0 ? '#FF7B7E' : '#98A2B3', action: navigateToRenewalScreen, triggerAction: triggerAction, handleNavigation: () => handlePageNavigation(2), setData: setData })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(CustomerListType, { title: 'Shortfall', iconName: IconTokens.SYSTEM_CREDIT_DLS, count: tabData[3]?.count > 0 ? tabData[3]?.count : '0', bgColor: tabData[3].count > 0 ? '#FF7B7E' : '#98A2B3', action: navigateToShortfallScreen, triggerAction: triggerAction, handleNavigation: () => handlePageNavigation(3), setData: setData }))));
    };
    const renderEmail = (email) => {
        const maxLength = 20;
        const atIndex = email.indexOf('@');
        if (atIndex === -1) {
            return email;
        }
        const localPart = email.slice(0, atIndex);
        const domainPart = email.slice(atIndex);
        if (localPart.length > maxLength) {
            return `${localPart.slice(0, maxLength)}...${domainPart}`;
        }
        else {
            return email;
        }
    };
    const renderCustomerCard = (customer) => {
        const title1 = currentActiveTab === 0 ? 'Phone Number: ' : currentActiveTab === 1 ? 'Status: ' : currentActiveTab === 2 ? 'Total credit limit: ' : 'Revised credit limit: ';
        const value1 = currentActiveTab === 0 ? `${customer?.phoneNumber.substr(3)}` : currentActiveTab === 1 ? `${customer?.status}` : currentActiveTab === 2 ? `₹${addCommasToNumber(customer?.totalCreditLimit)}` : `₹${addCommasToNumber(customer?.availableCreditLimit)}`;
        const title2 = currentActiveTab === 0 ? 'Available limit: ' : currentActiveTab === 1 ? 'Total due: ' : currentActiveTab === 2 ? 'Total outstanding: ' : 'Shortfall amount: ';
        const value2 = currentActiveTab === 0 ? `₹${addCommasToNumber(customer?.availableCreditLimit)}` : currentActiveTab === 1 ? `₹${customer?.totalDue}` : currentActiveTab === 2 ? `₹${addCommasToNumber(customer?.totalOutstanding)}` : `₹${addCommasToNumber(customer?.shortfallAmount)}`;
        const title3 = currentActiveTab === 0 ? 'Outstanding amount: ' : currentActiveTab === 1 ? 'Due on: ' : currentActiveTab === 2 ? 'Renew before: ' : 'Meet shortfall by: ';
        const value3 = currentActiveTab === 0 ? `₹${addCommasToNumber(customer?.principalOutstanding)}` : currentActiveTab === 1 ? `${customer?.dueOn}` : currentActiveTab === 2 ? `${customer?.renewalDueDate}` : `${customer?.meetShortfallBy}`;
        return (React.createElement(View, { style: { padding: 12, borderWidth: 1, borderColor: '#E4E7EC', borderRadius: 8, marginBottom: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: customer?.fullName, color: ColorTokens.Grey_Night }),
            currentActiveTab !== 0 && React.createElement(View, { style: { marginTop: 8, flexDirection: 'row', alignItems: 'center' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: title1, color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: value1, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8, flexDirection: 'row', alignItems: 'center' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: title2, color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: value2, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 8, flexDirection: 'row', alignItems: 'center' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: title3, color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: value3, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 12, marginHorizontal: -12 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: { flexDirection: 'row', paddingTop: 16 } },
                showJourney &&
                    React.createElement(React.Fragment, null,
                        React.createElement(TouchableOpacity, { style: { width: '30%', marginHorizontal: 4, alignItems: 'center', justifyContent: 'center' }, onPress: async () => {
                                if (navigateToCustomerJourney)
                                    await triggerAction({
                                        ...navigateToCustomerJourney,
                                        payload: {
                                            borrowerAccountId: customer?.accountId,
                                            name: customer?.fullName,
                                            ...navigateToCustomerJourney.payload
                                        }
                                    });
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'View as client', color: ColorTokens.Primary_100 })),
                        React.createElement(View, { style: { borderWidth: 1, borderColor: '#F3F5FC', marginTop: -16, marginBottom: -12 } })),
                React.createElement(TouchableOpacity, { style: { width: (!showLink && !showJourney) ? '100%' : (!showLink || !showJourney) ? '50%' : '30%', marginHorizontal: 4, alignItems: 'center', justifyContent: 'center' }, onPress: async () => {
                        await triggerAction({
                            ...navigateToCustomerDetails,
                            payload: {
                                numberOfFilterApplied,
                                filterObj,
                                customerViewData: customer,
                                currentActiveTabIndex: currentActiveTab,
                                ...navigateToCustomerDetails.payload,
                            }
                        });
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'View details', color: ColorTokens.Primary_100 })),
                showLink &&
                    React.createElement(React.Fragment, null,
                        React.createElement(View, { style: { borderWidth: 1, borderColor: '#F3F5FC', marginTop: -16, marginBottom: -12 } }),
                        React.createElement(TouchableOpacity, { style: { width: '35%', marginRight: 12, alignItems: 'center', justifyContent: 'center' }, onPress: async () => {
                                await triggerAction({
                                    ...navigateToShareLink,
                                    payload: {
                                        numberOfFilterApplied,
                                        filterObj,
                                        currentActiveTabIndex: currentActiveTab,
                                        customerViewData: customer,
                                        ...navigateToShareLink.payload,
                                    }
                                });
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Share with client', color: ColorTokens.Primary_100 }))))));
    };
    const renderItem = ({ item, index }) => {
        return renderCustomerCard(item);
    };
    const handleRenewalInfo = () => {
        setShowRenewalInfo(true);
    };
    const handleCloseRenewalContent = () => {
        setShowRenewalInfo(false);
    };
    const handleShortfallInfo = () => {
        setShowShortfallInfo(true);
    };
    const handleCloseShortfallContent = () => {
        setShowShortfallInfo(false);
    };
    const renderRenewalInfoContent = () => {
        return (React.createElement(RenewalContent, { onClose: handleCloseRenewalContent, triggerAction: triggerAction }));
    };
    const renderShortfallContent = () => {
        return (React.createElement(ShortfallContent, { onClose: handleCloseShortfallContent, triggerAction: triggerAction }));
    };
    const handleScroll = ({ nativeEvent }) => {
        if (isCloseToBottom(nativeEvent) && !hasReachedBottom) {
            setHasReachedBottom(true);
            if (currentPageNumber <= totalNoOfPages) {
                setCurrentpageNumber(currentPageNumber + 1);
                fetchMoreData();
            }
        }
        else if (!isCloseToBottom(nativeEvent) && hasReachedBottom) {
            setHasReachedBottom(false); // Reset flag when the user scrolls up
        }
    };
    const renderCustomerDetails = () => {
        return (React.createElement(View, { style: { margin: 16 } },
            React.createElement(TouchableOpacity, { style: { alignSelf: 'flex-start', paddingRight: 4 }, onPress: handleBackPress },
                React.createElement(View, { style: { flexDirection: 'row', padding: 4, borderRadius: 40, backgroundColor: '#F3F5FC' } },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_LEFT_DLS, color: ColorTokens.Primary_100, size: IconSizeTokens.XL }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: 'Go back', color: ColorTokens.Primary_100 }))),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(DropDownBaseInput, { label: 'Select customer type', data: customerTypeData, height: 180, value: customerTypeData[currentActiveTab]?.value, onValueSelect: async (value) => {
                        if (value !== "")
                            setCustomerType(value);
                        if (value === 'CUSTOMER') {
                            setData([]);
                            setCurrentpageNumber(2);
                            await triggerAction({
                                ...navigateToCustomerScreen,
                                payload: {
                                    searchText,
                                    currentPage: 1,
                                    ...navigateToCustomerScreen.payload
                                }
                            });
                            if (currentActiveTab !== 0) {
                                setNewFilterObj({});
                                setIsFilterSelected(false);
                            }
                            setCurrentActiveTab(0);
                        }
                        else if (value === 'INTEREST') {
                            setData([]);
                            setCurrentpageNumber(2);
                            await triggerAction({
                                ...navigateToInterestScreen,
                                payload: {
                                    searchText,
                                    currentPage: 1,
                                    ...navigateToInterestScreen.payload
                                }
                            });
                            if (currentActiveTab !== 1) {
                                setNewFilterObj({});
                                setIsFilterSelected(false);
                            }
                            setCurrentActiveTab(1);
                        }
                        else if (value === 'RENEWAL') {
                            setData([]);
                            setCurrentpageNumber(2);
                            await triggerAction({
                                ...navigateToRenewalScreen,
                                payload: {
                                    searchText,
                                    currentPage: 1,
                                    ...navigateToRenewalScreen.payload
                                }
                            });
                            if (currentActiveTab !== 2) {
                                setIsFilterSelected(false);
                                setNewFilterObj({});
                            }
                            setCurrentActiveTab(2);
                        }
                        else if (value === 'SHORTFALL') {
                            setData([]);
                            setCurrentpageNumber(2);
                            await triggerAction({
                                ...navigateToShortfallScreen,
                                payload: {
                                    searchText,
                                    currentPage: 1,
                                    ...navigateToShortfallScreen.payload
                                }
                            });
                            if (currentActiveTab !== 3) {
                                setIsFilterSelected(false);
                                setNewFilterObj({});
                            }
                            setCurrentActiveTab(3);
                        }
                    } })),
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', marginTop: 16, justifyContent: 'space-between' } },
                React.createElement(View, { style: { marginRight: 10, width: '70%' } },
                    React.createElement(TextInput, { state: InputStateToken.DEFAULT, type: InputTypeToken.SEARCH, keyboardType: KeyboardTypeToken.default, title: "Search customer", needSearchIcon: true, alphaNumericSpace: true, onChangeText: (text) => {
                            setSearchText(text);
                            handleSearch(text);
                        }, value: searchText, placeholder: 'Search by name or phone', clearTextAction: clearTextSearchAction })),
                React.createElement(View, { style: { marginRight: 16, width: '30%' } },
                    React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Search', onPress: () => {
                            handleSearch(searchText);
                        }, isDisabled: searchText?.length == 0 }))),
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Showing ${data?.length} ${actualPageSizeCustomer > 1 ? 'customers' : 'customer'}`, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, null,
                    isFilterSelected &&
                        React.createElement(View, { style: styles.filterNumberOverlay },
                            React.createElement(Typography, { label: numberOfFilterApplied, fontSize: FontSizeTokens.XXS, lineHeight: 18, color: ColorTokens.White, fontWeight: "400" })),
                    React.createElement(TouchableOpacity, { style: styles.filterButton, onPress: async () => {
                            setData([]);
                            if (currentActiveTab === 0 && navigateToCustomerFilter) {
                                await triggerAction({
                                    ...navigateToCustomerFilter,
                                    payload: {
                                        currentActiveTab,
                                        filterObj: newFilterObj,
                                        searchText,
                                        ...navigateToCustomerFilter.payload
                                    }
                                });
                            }
                            else if (currentActiveTab === 1 && navigateToInterestFilter) {
                                await triggerAction({
                                    ...navigateToInterestFilter,
                                    payload: {
                                        currentActiveTab,
                                        filterObj: newFilterObj,
                                        searchText,
                                        ...navigateToInterestFilter.payload
                                    }
                                });
                            }
                            else if (currentActiveTab === 2 && navigateToRenewalFilter) {
                                await triggerAction({
                                    ...navigateToRenewalFilter,
                                    payload: {
                                        currentActiveTab,
                                        filterObj: newFilterObj,
                                        searchText,
                                        ...navigateToRenewalFilter.payload
                                    }
                                });
                            }
                            else if (currentActiveTab === 3 && navigateToShortfallFilter) {
                                await triggerAction({
                                    ...navigateToShortfallFilter,
                                    payload: {
                                        currentActiveTab,
                                        filterObj: newFilterObj,
                                        searchText,
                                        ...navigateToShortfallFilter.payload
                                    }
                                });
                            }
                        } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "Filter", color: ColorTokens.Primary_100 }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(Icon, { name: IconTokens.Filter, size: IconSizeTokens.XL })))),
            (currentActiveTab === 2 && showRenewalOption) && React.createElement(View, { style: { marginTop: 16, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', backgroundColor: '#F3F5FC', borderRadius: 8, padding: 12, alignItems: 'center' } },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Why renew loan account?', color: ColorTokens.Grey_Night }),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: handleRenewalInfo },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: 'Know More', color: ColorTokens.Primary_100 }))),
                React.createElement(TouchableOpacity, { style: { backgroundColor: '#E7EBFA', borderRadius: 1000 }, onPress: () => { setShowRenewalOption(false); } },
                    React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.XL }))),
            (currentActiveTab === 3 && showShortfallOption) && React.createElement(View, { style: { marginTop: 16, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', backgroundColor: '#F3F5FC', borderRadius: 8, padding: 12, alignItems: 'center' } },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'What is shortfall?', color: ColorTokens.Grey_Night }),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 10 }, onPress: handleShortfallInfo },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: 'Know More', color: ColorTokens.Primary_100 }))),
                React.createElement(TouchableOpacity, { style: { backgroundColor: '#E7EBFA', borderRadius: 1000 }, onPress: () => { setShowShortfallOption(false); } },
                    React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.XL }))),
            React.createElement(ScrollView, { style: {} },
                dataFetched === true && isDataFetched === true && (customerData?.length === 0 || !customerData) &&
                    React.createElement(EmptyScreen, { activeTab: currentActiveTab, navigateToInterestCalculator: navigateToInterestCalculator, triggerAction: triggerAction, isFilterSelected: isFilterSelected, navigateToCustomerScreen: navigateToCustomerScreen, navigateToInterestScreen: navigateToInterestScreen, navigateToRenewalScreen: navigateToRenewalScreen, navigateToShortfallScreen: navigateToShortfallScreen, searchText: searchText, setIsFilterSelected: setIsFilterSelected, setNewFilterObj: setNewFilterObj }),
                dataFetched === false && React.createElement(ShimmerTable, null)),
            React.createElement(ScrollView, { scrollEventThrottle: 400, onScroll: handleScroll, style: {
                    height: height - 300,
                    paddingBottom: 80,
                    marginTop: 16,
                }, ref: scrollViewRef },
                React.createElement(FlatList, { removeClippedSubviews: true, windowSize: data?.length || 50, data: data, keyExtractor: (item, index) => "" + index, renderItem: renderItem, nestedScrollEnabled: true, ListFooterComponent: currentPageNumber <= totalNoOfPages ? React.createElement(ActivityIndicator, { color: '#1434CB', size: 22 }) : React.createElement(React.Fragment, null) }))));
    };
    const renderContent = () => {
        return showShortfallInfo ? renderShortfallContent() : showRenewalInfo ? renderRenewalInfoContent() : showDashboard ? renderDashboardDetails() : renderCustomerDetails();
    };
    return (React.createElement(BoilerPlate, { height: height - 40, backgroundColor: showDashboard ? ColorTokens.Grey_Milk_1 : ColorTokens.White, bottomChildren: React.createElement(React.Fragment, null) }, renderContent()));
};
const styles = StyleSheet.create({
    filterButton: {
        flexDirection: 'row',
        borderRadius: 23,
        borderWidth: 1,
        borderColor: '#1434CB',
        paddingHorizontal: 16,
        paddingVertical: 4,
        alignItems: 'center',
    },
    filterNumberOverlay: {
        alignItems: 'center',
        alignSelf: 'flex-end',
        justifyContent: 'center',
        width: 20,
        height: 20,
        marginBottom: 12,
        backgroundColor: "#1434CB",
        borderRadius: 32,
        top: 0,
        right: 0,
        bottom: 12,
        marginRight: 8,
        position: 'absolute'
    }
});
export default CustomerMobDashboard;
